<template>
  <v-flex>
    <notify-custom
    :showNotify="show"
    :type="tipoNotify"
    :message="msgNotify"
    :icontext="iconNotify"
    :color="color">
  </notify-custom>
    <v-data-table
      :page="page"
      :pageCount="numberOfPages"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :headers="headers"
      :items="objetos"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Logs {{nameDropshipper}}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            class="text-xs-center"
            v-model="search"
            append-icon="search"
            :label="txtMessages.txtSearch"
            single-line
            hide-details
            @change="listar()"
            >
          </v-text-field>
          <v-spacer></v-spacer>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
           <vue-excel-xlsx
              :data="objExcel"
              :columns="columns"
              :file-name="'logsList'"
              :file-type="'xlsx'"
              :sheet-name="'logs'"
              >
              <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                class="ma-2 white--text"
                fab
                small
                v-bind="attrs"
                v-on="on"
              >
              <v-icon dark>
                file_download
              </v-icon>
            </v-btn>
              </template>
               <span>{{txtMessages.txtExport}}</span>
            </v-tooltip>
          </vue-excel-xlsx>
        </v-toolbar>
        <v-toolbar flat>
          <v-toolbar-title>
            <small>
            </small>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
            <v-select
                  v-model="typeLogs"
                  :items="itemsType"
                  :label="txtMessages.lblSelectTypeLog"
                  @change="listar()"
            ></v-select>
             <v-spacer></v-spacer>
            <v-select
              v-model="titleLogs"
            :items="itemsTitle"
            :label="txtMessages.lblSelectTitleLog"
            @change="listar()"
            ></v-select>
             <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.created_at="{ item }">
        <td>
          {{$moment(item.created_at).format('YYYY-MM-DD HH:MM')}}
        </td>
      </template>
      <template v-slot:item.type="{ item }">
        <td>
        <template v-if="item.type === 0">
          <v-icon
            color="green"
            class="mr-2"
            > info
          </v-icon> Info
        </template>
        <template v-if="item.type === 1">
          <v-icon
            color="orange"
            class="mr-2"
            > warning
          </v-icon> {{txtMessages.txtWarning}}
        </template>
        <template v-if="item.type === 2">
          <v-icon
            color="red"
            class="mr-2"
            > bug_report
          </v-icon>Error
        </template>
        </td>
      </template>
       <template v-slot:item.options="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              class="mr-2"
              v-bind="attrs"
              v-on="on"
              @click="showdetailModal(item)"
              > edit
            </v-icon>
          </template>
           <span>{{txtMessages.txtDetails}}</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="listar()"
        >
          {{txtMessages.txtReset}}
        </v-btn>
      </template>
    </v-data-table>
    </v-flex>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import notifyCustom from './partials/notifyDialog.vue';
import langMsg from '../config/generalMessages';

export default {
  components: {
    'notify-custom': notifyCustom,
  },
  data() {
    return {
      txtMessages: langMsg,
      itemsType: ['none', 'Info', 'Warning', 'Error'],
      itemsTitle: ['none', 'product', 'inventory', 'status', 'order', 'cron'],
      typeLogs: null,
      titleLogs: null,
      dialog: false,
      search: '',
      objetos: [],
      objExcel: [],
      dialogDelete: false,
      page: 1,
      numberOfPages: 10,
      options: {},
      totalItems: 0,
      headers: [
        {
          text: langMsg.txtCreationDate, align: 'start', value: 'created_at', sortable: false,
        },
        { text: langMsg.txtType, value: 'type', sortable: false },
        { text: langMsg.txtTitle, value: 'title', sortable: false },
        { text: langMsg.txtContent, value: 'content', sortable: false },
        { text: langMsg.txtOrderName, value: 'orderName', sortable: false },
        { text: langMsg.txtOrderNumber, value: 'orderNumber', sortable: false },
      ],
      columns: [
        { label: langMsg.txtCreationDate, field: 'created_at' },
        { label: langMsg.txtContent, field: 'content' },
        { label: langMsg.txtTitle, field: 'title' },
        { label: langMsg.txtType, field: 'type', dataFormat: this.getTypeLogReverse },
        { label: langMsg.txtOrderName, field: 'orderName' },
        { label: langMsg.txtOrderNumber, field: 'orderNumber' },
      ],
      // eslint-disable-next-line
      nameDropshipper: '',
      nameConfig: '',
      idDropshipper: '',
      data: {},
      // --- events data ---
      loading: false,
      tipoNotify: 'Info',
      msgNotify: '--',
      show: false,
      color: 'primary',
      iconNotify: 'info',
    };
  },
  computed: {
  },
  watch: {
    dialog(val) {
      return val || this.close();
    },
    dialogDelete(val) {
      return val || this.closeDelete();
    },
    options: {
      handler() {
        this.listar();
      },
    },
    deep: true,
  },
  created() {
    this.$store.commit('SET_LAYOUT', 'principal-layout');
  },
  mounted() {
    axios.defaults.headers.common.authorization = this.$store.state.token;
    this.idDropshipper = this.$route.params.id;
    this.getOne(this.idDropshipper);
  },

  methods: {
    notifyMessage(type, message) {
      this.tipoNotify = type;
      this.msgNotify = message;
      this.show = true;
      if (type === 'Info') {
        this.color = 'primary';
        this.iconNotify = 'info';
      } else if (type === 'Success') {
        this.color = 'green';
        this.icontext = 'check_circle';
      } else if (type === 'Error') {
        this.color = 'red';
        this.icontext = 'error';
      }
    },
    getTypeLog(type) {
      if (!type === null || type === 'none') return false;
      switch (type) {
        case 'Info':
          return 0;
        case 'Warning':
          return 1;
        case 'Error':
          return 2;
        default:
          return false;
      }
    },
    getTypeLogReverse(type) {
      switch (type) {
        case 0:
          return 'Info';
        case 1:
          return 'Warning';
        case 2:
          return 'Error';
        default:
          return '-';
      }
    },
    getOne(id) {
      if (id !== 'general') {
        axios.get(`dropshipper/get/${id}`).then((res) => {
          this.data = res.data.body;
          this.nameDropshipper = `${this.data.name} - ${this.data.contact.name}`;
          this.nameConfig = this.data.config.shop;
          return 'ok';
        });
      }
    },
    listar() {
      this.loading = true;
      const { page, itemsPerPage } = this.options;
      const items = itemsPerPage || 10;
      const pageNumber = page || 1;
      this.idDropshipper = this.$route.params.id;
      const { name } = this.$route.query;
      this.objetos = [];
      let urlConsult = `log/get/dropshipper/${this.idDropshipper}?name=${name || ''}&limit=${items}&page=${pageNumber}`;
      const type = this.getTypeLog(this.typeLogs);
      const title = this.titleLogs || false;
      const search = this.search === '' ? false : this.search;
      if (type || type === 0) urlConsult = `${urlConsult}&type=${type}`;
      if (title) urlConsult = `${urlConsult}&title=${title}`;
      if (search) urlConsult = `${urlConsult}&search=${search}`;
      axios.get(urlConsult).then((res) => {
        this.loading = false;
        this.objetos = res.data.body.docs;
        this.objExcel = res.data.body.docs.map((a) => {
          const doc = { ...a };
          doc.created_at = moment(a.created_at).format('YYYY-MM-DD HH:MM');
          return doc;
        });
        this.totalItems = res.data.body.totalDocs;
        this.numberOfPages = res.data.body.pages;
      });
    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    clean() {
      const empty = '';
      this.nameDropshipper = empty;
    },
  },
};
</script>
